<script>
import { debounce } from "/vodalys/.jslibs/";

import WhitelistListingAddDomain from "./WhitelistListingAddDomain.vue";
import { asyncAngularInvoke } from "/vodalys/vvuejs";
export default {
  translate25Context: ["whitelist"],
  components: { WhitelistListingAddDomain },
  props: ["component", "handler"],
  data: function () {
    return {
      search: "",
      pending: false,
      selected: {},
      selectAllMatching: false,
      skipCodePending: false,
      exportPending: false,
      domainModalShow: false,
      domainModalPending: false,
      domainModalItem: null,
      domainModalPlaceholder: "",
    };
  },
  computed: {
    items() {
      return Object.values(this.component.items || {});
    },
    selectedItems() {
      return this.items.filter((item) => this.selected[item["#id"]]);
    },
    selectedNids() {
      return Object.keys(this.component.items || {}).filter(
        (nid) => this.selected[this.component.items[nid]["#id"]]
      );
    },
    allSelected() {
      return (
        this.selectAllMatching ||
        (this.items.length > 0 && this.selectedItems.length == this.items.length)
      );
    },
    selectedCount() {
      return this.selectAllMatching ? this.component.total : this.selectedItems.length;
    },
    canSelectAllMatching() {
      return (
        !this.selectAllMatching &&
        this.allSelected &&
        this.component.total > this.items.length
      );
    },
    codeRequired() {
      return !this.component.skip_code;
    },
  },
  watch: {
    "component.items"() {
      const ids = this.items.map((item) => item["#id"]);
      for (const id of Object.keys(this.selected)) {
        if (!ids.includes(id)) {
          this.$delete(this.selected, id);
        }
      }
    },
    "component.select": {
      deep: true,
      handler() {
        this.clearSelection();
      },
    },
  },
  methods: {
    isSelected(item) {
      return this.selectAllMatching || !!this.selected[item["#id"]];
    },
    setSelected(item, value) {
      if (this.selectAllMatching && !value) {
        this.selectAllMatching = false;
        for (const other of this.items) {
          this.$set(this.selected, other["#id"], true);
        }
      }

      if (value) {
        this.$set(this.selected, item["#id"], true);
      } else {
        this.$delete(this.selected, item["#id"]);
      }
    },
    toggleAll() {
      if (this.allSelected) {
        this.clearSelection();
        return;
      }
      for (const item of this.items) {
        this.setSelected(item, true);
      }
    },
    clearSelection() {
      this.selected = {};
      this.selectAllMatching = false;
    },
    setSkipCode(skipCode) {
      this.skipCodePending = true;
      const done = () => {
        this.skipCodePending = false;
      };
      return this.handler
        .action(this.component["#id"], "set_skip_code", [skipCode])
        .then(done, done);
    },
    toggleCodeRequired() {
      if (this.skipCodePending) return;

      return this.setSkipCode(this.codeRequired);
    },
    exportCsv() {
      if (this.exportPending) return;

      this.exportPending = true;
      const done = () => {
        this.exportPending = false;
      };
      return this.handler
        .action(this.component["#id"], "export")
        .then((r) => {
          const csv = r && r["#result"];
          if (typeof csv != "string") return;

          const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
          const link = document.createElement("a");
          link.href = url;
          link.download = "whitelist-" + new Date().toISOString().slice(0, 10) + ".csv";
          document.body.appendChild(link);
          link.click();
          link.remove();
          URL.revokeObjectURL(url);
        })
        .then(done, done);
    },
  },
  created() {
    this.doSearch = debounce(() => {
      this.handler.action(this.component["#id"], "set_search", [this.search]);
    }, 300);

    this.addAddress = () => {
      let _zis = this;
      let hint = {
        message: null,
      };
      asyncAngularInvoke(($rootScope, $rootElement, v17Modal) => {
        v17Modal.textarea($rootScope, $rootElement.find("body"), {
          title: this.$vt("Add email addresses"),
          message: this.$vt("Enter one or more email addresses"),
          hint: hint,
          inputChange: debounce(async (input) => {
            let r = await this.handler.action(
              this.component,
              "parse_addresses",
              [input]
            );

            const parsed = r && r["#result"];
            if (!parsed) {
              hint.message = null;
              return;
            }

            const parts = [
              this.$vtc("one addresse will be added | {count} addresses will be added", parsed.new, { count: parsed.new }),
            ];
            if (parsed.existing > 0) {
              parts.push(
                this.$vtc("one already in the list | {count} already in the list", parsed.existing, { count: parsed.existing })
              );
            }
            if (parsed.invalid.length > 0) {
              const shown = parsed.invalid.slice(0, 5).join(", ");
              parts.push(
                this.$vtc("one invalid | {count} invalid", parsed.invalid.length, { count: parsed.invalid.length }) +
                  " : " +
                  shown +
                  (parsed.invalid.length > 5 ? "…" : "")
              );
            }
            hint.message = parts.join(" · ");
          }, 1000),
          okLabel: this.$vt("Add"),
          ok: function (input) {
            return _zis.handler.action(_zis.component, "add_addresses", [
              input,
            ]);
          },
        });
      });
    };

    this.addDomain = () => {
      this.domainModalItem = null;
      this.domainModalPlaceholder = "";
      this.domainModalShow = true;
    };

    this.updateDomain = (item) => {
      this.domainModalItem = item;
      this.domainModalPlaceholder = item.domain;
      this.domainModalShow = true;
    };

    this.addOrUpdateDomain = (domain) => {
      this.domainModalPending = true;
      var _zis = this;
      if (this.domainModalItem) {
        this.handler
          .action(this.domainModalItem["#id"], "update", [domain])
          .then(
            function () {
              _zis.domainModalPending = false;
              _zis.domainModalShow = false;
            },
            function () {
              _zis.domainModalPending = false;
            }
          );
      } else {
        this.handler.action(_zis.component, "add_domain", [domain]).then(
          function () {
            _zis.domainModalPending = false;
            _zis.domainModalShow = false;
          },
          function () {
            _zis.domainModalPending = false;
          }
        );
      }
    };

    this.remove = () => {
      let _zis = this;
      let removeMatching = this.selectAllMatching;
      let nidsToRemove = this.selectedNids;

      asyncAngularInvoke(function ($rootScope, $rootElement, v17Modal) {
        v17Modal.yesNo($rootScope, $rootElement.find("body"), {
          title: _zis.$vt("Remove?"),
          message:
            _zis.$vt("Are you sure you want to remove ") +
            _zis.selectedCount +
            _zis.$vt(" item(s)?"),
          yesType: "negative",
          yesLabel: _zis.$vt("Remove"),
          noLabel: _zis.$vt("Cancel"),
          yes: function () {
            if (removeMatching) {
              _zis.clearSelection();
              return _zis.handler.action(_zis.component["#id"], "remove_matching");
            }

            _zis.clearSelection();
            return _zis.handler.action(_zis.component["#id"], "remove_multiple", [nidsToRemove]);
          },
        });
      });
    };

    this.updateAddress = (item) => {
      let _zis = this;
      asyncAngularInvoke(function ($rootScope, $rootElement, v17Modal) {
        v17Modal.input($rootScope, $rootElement.find("body"), {
          title: _zis.$vt("Edit address"),
          placeholder: item.address,
          ok: function (a) {
            return _zis.handler.action(item["#id"], "update", [a]);
          },
        });
      });
    };

    this.sort = (column) => {
      this.handler.action(this.component["#id"], "sort", [
        this.component.select.order_direction == "ASC" ? "DESC" : "ASC",
        column,
      ]);
    };

    this.more = () => {
      if (this.pending || !this.component.more_to_load) return;

      const done = () => {
        this.pending = false;
      };
      this.pending = true;
      this.handler.action(this.component["#id"], "load_more").then(done, done);
    };
  },
};
</script>
    
<template>
  <div class="f-whitelist-listing">
    <whitelist-listing-add-domain
      v-if="domainModalShow"
      :pending="domainModalPending"
      @ok="addOrUpdateDomain($event)"
      @close="domainModalShow = false"
      :placeholder="domainModalPlaceholder"
    >
    </whitelist-listing-add-domain>

    <div class="f-card f-content">
      <div class="f-toolbar">
        <div class="f-search">
          <f-icon class="f-icon" icon="fa6-magnifying-glass"></f-icon>
          <input
            @click.stop=""
            @input="doSearch()"
            type="search"
            v-model.trim="search"
            :placeholder="$vt('Search...')"
          />
          <f-button
            type="icon small"
            v-if="search"
            v-on:click.stop="
              search = '';
              doSearch();
            "
          >
            <f-icon icon="fa6-xmark"></f-icon>
          </f-button>
        </div>
        <div class="f-toolbar-actions">
          <f-button type="primary" @click="addAddress()"
            ><f-icon icon="fa6-plus"></f-icon>{{ $vt("Email address") }}</f-button
          >
          <f-button type="secondary" @click="addDomain()"
            ><f-icon icon="fa6-plus"></f-icon>{{ $vt("Domain") }}</f-button
          >
        </div>
      </div>

      <div class="f-table">
        <div class="f-table-header">
          <f-checkbox
            class="f-select-all"
            :default="allSelected"
            :checked="allSelected"
            check-watch
            @update:checked="toggleAll()"
          ></f-checkbox>
          <div
            class="f-table-header-sort"
            @click="sort('name')"
            :class="{ selected: component.select.order_column == 'name' }"
          >
            {{ $vt("Email address or domain") }}<f-icon
              v-if="component.select.order_column == 'name'"
              :icon="
                component.select.order_direction == 'ASC'
                  ? 'fa6-chevron-up'
                  : 'fa6-chevron-down'
              "
            >
            </f-icon>
          </div>
        </div>
        <div class="f-table-body">
          <div class="f-empty" v-if="items.length == 0">
            <f-icon icon="fa6-user-shield"></f-icon>
            <div>{{ $vt("The list is empty") }}</div>
            <div class="f-empty-hint" v-if="!search">
              {{ $vt("Add email addresses or whole domains to allow guests.") }}
            </div>
          </div>
          <f-sexy-scroll
            autoscroll-event
            :autoscroll-tolerance="100"
            @autoload="$event && more()"
          >
            <div
              class="f-table-line"
              :class="{ checked: isSelected(item) }"
              v-for="item in component.items"
              v-bind:key="item['#id']"
            >
              <f-checkbox
                :default="isSelected(item)"
                :checked="isSelected(item)"
                check-watch
                @update:checked="setSelected(item, $event)"
              >
                <div
                  class="f-whitelist-item"
                  v-if="item['#type'].includes('whitelist:address')"
                >
                  <f-icon icon="fa6-user"></f-icon>
                  <div class="f-whitelist-value">{{ item.address }}</div>
                </div>
                <div
                  class="f-whitelist-item"
                  v-if="item['#type'].includes('whitelist:domain')"
                >
                  <f-icon icon="fa6-at"></f-icon>
                  <div class="f-whitelist-value f-whitelist-domain">
                    <strong>{{ $vt("every address") }}</strong>
                    <span>@{{ item.domain }}</span>
                  </div>
                  <span class="f-badge">{{ $vt("Domain") }}</span>
                </div>
              </f-checkbox>
              <f-button
                class="f-edit"
                type="icon"
                :title="$vt('Edit')"
                @click.stop="
                  item['#type'].includes('whitelist:domain')
                    ? updateDomain(item)
                    : updateAddress(item)
                "
              >
                <f-icon icon="fa6-pen"></f-icon>
              </f-button>
            </div>
            <div class="f-table-line more" v-if="component.more_to_load">
              <f-icon spin icon="fa6-circle-notch" v-if="pending"></f-icon>
            </div>
          </f-sexy-scroll>
        </div>
        <div class="f-selection-bar" v-if="selectedCount > 0">
          <div class="f-selection-info">
            <span class="f-selection-count">{{
              $vtc("one selected | {count} selected", selectedCount, { count: selectedCount })
            }}</span>
            <f-button
              v-if="canSelectAllMatching"
              type="link"
              @click="selectAllMatching = true"
              >{{
                $vtc("Select the item | Select all {count} items", component.total, { count: component.total })
              }}</f-button
            >
            <f-button v-if="selectAllMatching" type="link" @click="clearSelection()">{{
              $vt("Clear selection")
            }}</f-button>
          </div>
          <f-button type="negative small" @click="remove()"
            ><f-icon icon="fa6-trash"></f-icon>{{ $vt("Remove") }}</f-button
          >
        </div>
      </div>
    </div>

    <div class="f-side">
      <div class="f-card f-access" :class="{ pending: skipCodePending }">
        <div class="f-access-title">
          <f-icon icon="fa6-gear"></f-icon>
          {{ $vt("Settings") }}
        </div>

        <template v-if="!component.hide_code_setting">
          <f-toggle
            :enabled="codeRequired"
            :labels="{ enabled: $vt('Required'), disabled: $vt('Disabled') }"
            @toggle="toggleCodeRequired()"
          >
            {{ $vt("Verification code by email") }}
          </f-toggle>

          <f-hint v-if="codeRequired" type="positive" icon="fa6-circle-info">
            <template #message>{{
              $vt("Guests enter their email address, then the code they receive by email.")
            }}</template>
          </f-hint>

          <f-hint v-else type="notice" icon="fa6-circle-exclamation">
            <template #title>{{ $vt("Verification code disabled") }}</template>
            <template #message>{{
              $vt("An allowed email address or domain is enough to access the page.")
            }}</template>
          </f-hint>
        </template>

        <div class="f-export">
          <f-button type="secondary" :disabled="exportPending" @click="exportCsv()"
            ><f-icon :spin="exportPending" :icon="exportPending ? 'fa6-circle-notch' : 'fa6-download'"></f-icon
            >{{ $vt("Export list") }}</f-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.whitelist-listing-ng-component {
  width: 100%;
}

.f-whitelist-listing .f-access .f-hint {
  font-size: 13px;
  line-height: 18px;

  &.positive {
    border-left-color: var(--statusPositive);
    background-color: var(--statusPositive-a10);

    .icon {
      color: var(--statusPositive);
    }
  }

  &.notice {
    border-left-color: var(--statusNotice);
    background-color: var(--statusNotice-a10);

    .icon {
      color: var(--statusNotice);
    }
  }
}
</style>

<style lang="scss" scoped>
.f-whitelist-listing {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 16px;

  .f-card {
    background-color: var(--black);
    border-radius: 8px;
    box-shadow: 0 4px 16px #1616151a;
    padding: 16px;
  }

  .f-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1 1 auto;
    min-width: 0;
  }

  .f-side {
    flex: 0 0 380px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  @media (max-width: 1000px) {
    flex-direction: column-reverse;

    .f-side {
      flex: 0 0 auto;
    }
  }

  .f-access {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    &.pending {
      pointer-events: none;
    }

    .f-access-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      font-weight: bold;
      color: var(--white-a75);

      .f-icon {
        color: var(--primary);
      }
    }

    .f-toggle {
      flex: 0 0 auto;
    }

    .f-export {
      padding-top: 16px;
      border-top: 1px solid var(--white-a10);

      .f-button {
        width: 100%;
        justify-content: center;
      }

      .f-icon {
        margin-right: 6px;
      }
    }
  }

  .f-toolbar {
    display: flex;
    align-items: center;
    gap: 16px;

    .f-search {
      flex: 1 1 auto;
      height: 46px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding: 0 8px 0 12px;
      border-radius: 6px;
      background: var(--white-a5);

      .f-icon {
        font-size: 16px;
        opacity: 0.6;
      }

      input {
        background-color: transparent;
        color: inherit;
        border: none;
        outline: none;
        flex: auto;
        margin-left: 10px;
        padding: 5px 0;
        font-size: 14px;
      }
    }

    .f-toolbar-actions {
      display: flex;
      gap: 8px;
      flex: 0 0 auto;

      .f-icon {
        margin-right: 6px;
      }
    }
  }

  .f-table {
    flex: 1 1 auto;
    min-height: 400px;
    display: flex;
    flex-direction: column;

    .f-table-header {
      display: flex;
      align-items: center;
      gap: 8px;
      min-height: 48px;
      padding: 0 24px 0 0;
      border-bottom: 2px solid var(--white-a10);
      color: var(--white-a75);
      font-size: 14px;
      font-weight: bold;

      .f-table-header-sort {
        flex: 1 1 auto;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        user-select: none;

        &:hover {
          opacity: 0.75;
        }

        .f-icon {
          margin-left: auto;
          width: 40px;
        }
      }
    }

    .f-selection-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      margin: 8px 16px 0 0;
      padding: 8px 8px 8px 16px;
      border-radius: 8px;
      background: var(--white-a5);

      .f-selection-info {
        display: flex;
        align-items: center;
        gap: 16px;
        min-width: 0;
      }

      .f-selection-count {
        font-size: 14px;
        font-weight: bold;
        color: var(--white-a75);
        white-space: nowrap;
      }

      .f-icon {
        margin-right: 6px;
      }
    }

    .f-table-body {
      height: 0;
      flex: 1 1 100%;
      display: flex;
      flex-direction: column;

      .f-empty {
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        opacity: 0.5;

        > .f-icon {
          font-size: 32px;
          margin-bottom: 8px;
        }

        .f-empty-hint {
          font-weight: normal;
          font-size: 13px;
        }
      }

      .f-sexy-scroll {
        scrollbar-gutter: stable;
      }

      .f-table-line {
        display: flex;
        align-items: center;
        border-bottom: 1px solid var(--white-a10);
        padding: 0 8px 0 0;
        border-radius: 4px;
        transition: background-color ease 0.15s;

        &:hover,
        &.checked {
          background-color: var(--white-a5);
        }

        .f-checkbox {
          flex: 1 1 auto;
          min-width: 0;
          height: 50px;
          display: flex;
          align-items: center;

          &:hover,
          &:hover:active {
            background-color: transparent;
          }
        }

        .f-whitelist-item {
          display: flex;
          align-items: center;
          gap: 10px;
          min-width: 0;

          .f-icon {
            color: var(--primary);
            font-size: 14px;
          }

          .f-whitelist-value {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            min-width: 0;
          }

          .f-whitelist-domain {
            display: flex;
            align-items: baseline;
            gap: 4px;

            strong {
              display: inline;
              flex: 0 0 auto;
            }

            span {
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .f-badge {
            font-size: 11px;
            font-weight: bold;
            text-transform: uppercase;
            padding: 2px 6px;
            border-radius: 4px;
            color: var(--primary);
            background: var(--white-a5);
          }
        }

        .f-edit {
          flex: 0 0 auto;
          color: var(--white-a50);
          font-size: 14px;
          transition: color ease 0.15s, background-color ease 0.15s;

          &:hover {
            color: var(--primary);
            background: var(--white-a10);
          }
        }

        &.more {
          justify-content: center;
          min-height: 40px;
          border-bottom: none;
          opacity: 0.5;

          &:hover {
            background-color: transparent;
          }
        }
      }
    }
  }
}
</style>
